module.exports = __webpack_public_path__ + "img/youtubers-for-human-rights.712d5440.jpg";